import React, { useState, useEffect } from "react";
import { IconSettings, Textarea } from "@salesforce/design-system-react";

const CustomTextarea = ({ id, label, value, required, onChange }) => {
  return (
    <div className="slds-p-top_x-small form-item">
      <IconSettings iconPath="/icons">
        <Textarea
          id={id}
          label={label}
          value={value}
          required={required}
          onChange={onChange}
        />
      </IconSettings>
    </div>
  );
};

CustomTextarea.defaultProps = {
  id: "textarea-1",
  label: "REPLACE label",
  value: "",
  onChange: () => console.log("ATTACH FORM UPDATE FUNCTION"),
};

export default CustomTextarea;
